<template>
<div>
  <VehicleComponent/>
</div>
</template>

<script>
import VehicleComponent from '@/components/VehicleComponent.vue';

export default {
name: 'vehicleView',
components: {
    VehicleComponent,
    },
}
</script>

<style>

</style>